import { API_ROOT } from '../config.js'
import * as actions from '../actions/acCommon'

export const CALL_API = Symbol('Call API')

const callApi = (endpoint, init, prefixURL) => {
	const fullUrl = API_ROOT + prefixURL + endpoint
	return fetch(fullUrl, init)
}

let perf;
if(window.performance){
	perf = performance.now.bind(performance)
} else {
	perf = Date.now
}

// This variable will be incremented by one at each request,
// to give an id to each of them, and thus be able to keep track.
let requestIncrementalTracker = 0
export default store => next => action => {
	if (typeof action[CALL_API] === 'undefined') {
		return next(action)
	}

	let { endpoint, init, types, requestMeta, prefixURL } = action[CALL_API]
	let [requestType, successType, failureType] = types

	init.headers = {
		'Content-Type': 'application/json',
		'X-Language': store.getState().i18nState.lang
	}

	if(requestType !== 'SIGNIN_REQUEST' ) {
		let { metadataReducer: { auth } } = store.getState()
		init.headers.Authorization = 'Bearer ' + auth.token
	}
	if (requestType === 'CHECKTOKEN_REQUEST'){
		init.headers.Authorization = 'Bearer ' + action[CALL_API].requestMeta.token
	}

	requestIncrementalTracker += 1
	const currentRequestID = requestIncrementalTracker
	next({ type: requestType, requestID: currentRequestID })
	let networkCallStart = perf()
	let networkCallEnd;

	next(actions.showSpinner(requestMeta.spinnerMessageKey, currentRequestID))

	return callApi(endpoint, init, prefixURL)
		.then(response => {
			if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development"){
				console.group(`%c${requestType}`, "font-size:1.1em;font-weight:bold;text-decoration:underline;", init.method, response.url.split(prefixURL, 2)[1])
				console.log("%cData sent:", "color: darkslategray", init.body ? JSON.parse(init.body) : init)
			}
			networkCallEnd = perf()
			if (!response.ok) {
				return response.json().then(json => Promise.reject({ json, status: response.status }))
			}
			return response.json()
		})
		.then(data => {
			let fetchTime = (networkCallEnd - networkCallStart) / 1000
			if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development"){
				console.log("%cRequest ID", "color:lightblue", currentRequestID)
				console.log("%cSuccess!", "color:#bada55;")
				console.log("%cData:", "color:steelblue;", data)
				console.log("%cFetch time was:", "color: tomato", fetchTime, "seconds")
				console.groupEnd()
			}
			next({ type: successType, requestID: currentRequestID, fetchTime, data, requestMeta })
			next(actions.hideSpinner(currentRequestID))
			return { actionType: successType, response: data, requestMeta: requestMeta }
		}, error => {
			let fetchTime = (networkCallEnd - networkCallStart) / 1000
			if(process.env.REACT_APP_STAGING || process.env.NODE_ENV === "development"){
				console.log("%cErrors:", "color:red;font-size:1.1em;font-weight:bold;", error)
				console.log("%cFetch time was:", "color: tomato", fetchTime, "seconds")
				console.groupEnd()
			}
			next({ type: failureType, requestID: currentRequestID, error: error, requestMeta })
			next(actions.hideSpinner(currentRequestID))
			if(error.json && error.json.error !== null && (typeof error.json.error === "string" || typeof  error.json.error === "object")){
				next(actions.backendError(error.json, error.status))
			}
			return { actionType: failureType, response: error, requestMeta: requestMeta }
		})
}


// WEBPACK FOOTER //
// ./src/middleware/api.js